import { render, staticRenderFns } from "./TempPrescription.vue?vue&type=template&id=b6a76a88&scoped=true"
import script from "./TempPrescription.vue?vue&type=script&lang=js"
export * from "./TempPrescription.vue?vue&type=script&lang=js"
import style0 from "./TempPrescription.vue?vue&type=style&index=0&id=b6a76a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a76a88",
  null
  
)

export default component.exports